import { render, staticRenderFns } from "./appli.vue?vue&type=template&id=161d8d7b"
import script from "./appli.vue?vue&type=script&lang=js"
export * from "./appli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports